import { Card, Statistic, StatisticProps } from "antd";

export default function AppStatistic(props: StatisticProps) {
  return (
    <Card bordered={false}>
      <Statistic valueStyle={{ color: "#3f8600" }} {...props} />
    </Card>
  );
}
